<!-- Extends StandardLayout -->
<template>
  <StandardLayout>
    <div class="mx-12 my-6" slot="main">
      <div class="d-flex flex-row align-center justify-space-between">
        <h1 class="outfit-regular">{{ title }}</h1>
        <slot name="button" />
      </div>
      <v-text-field v-if="showSearch" v-model="search" label="Search" prepend-inner-icon="mdi-magnify" outlined hide-details></v-text-field>
      <slot name="filters" />
      <div class="mt-4 d-flex flex-row flex-wrap">
        <div v-for="(item, index) in filteredItems" :key="item.id || index">
          <slot name="card" :item="item" :index="index">
            <v-card class="ma-2" width="300">
              <div class="px-4 pt-4 cal-sans-regular font-size-20">
                {{ item.title || item.name || 'Untitled' }}
              </div>
            </v-card>
          </slot>
        </div>
      </div>
      <div>
        <slot name="main" />
      </div>
    </div>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'
export default {

  name: 'LibraryLayout',
  
  components: {
    StandardLayout,
  },

  props: {
    title: { type: String, default: 'Library' },
    items: { type: Array, default: () => [] },
    showSearch: { type: Boolean, default: true },
  },

  data() {
    return {
      search: '',
    }
  },

  computed: {
    filteredItems() {
      if (!this.search) return this.items
      const s = this.search.toLowerCase()
      return this.items.filter((it) => {
        const title = (it && (it.title || it.name || '')) + ''
        if (title && title.toLowerCase().includes(s)) return true
        try {
          return JSON.stringify(it).toLowerCase().includes(s)
        } catch (e) {
          return false
        }
      })
    }
  },
}
</script>